<div class="container-fluid">
    <div class="table-header">
        <h5>Equipment GE Predix</h5>
        <div class="controls">
            <button mat-button (click)="addEquipment()" [disabled]="!(canEdit$ | async)">
                <mat-icon svgIcon="plus" />
                Add Equipment
            </button>

            @if (showDelete) {
                <button mat-button (click)="deleteEquipment()" [disabled]="!(canEdit$ | async)">
                    <mat-icon svgIcon="trash-can" />
                    Delete
                </button>
            } 
            
            <button mat-button (click)="refresh()" [disabled]="!(canEdit$ | async)">
                <mat-icon>refresh</mat-icon>
                Refresh
            </button>
            
            @if (isDev) {
                <button mat-button (click)="export()" disabled>
                    <mat-icon svgIcon="save" />
                    Export Equipment
                </button>
            }
        </div>
    </div>

    <div class="table-container">
        <div class="table-scroll-wrapper">
            <table mat-table [dataSource]="dataSource" matSort class="report-table" fixedLayout="true">
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()"
                            aria-label="Select all"></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()" (change)="checkRow(row)"
                            [checked]="selection.isSelected(row)"
                            aria-label="Select row"></mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="equipmentTag">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Equipment Tag">
                        Equipment Tag
                        <app-table-column-filter class="column-filter" [class.active]="isActive('equipmentTag')" (filterChange)="applyFilter($event, 'equipmentTag')" />
                    </th>
                    <td mat-cell *matCellDef="let report">
                        <a class="blue-link" [routerLink]="['edit', report.id]">{{ report.equipmentTag }}</a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="descriptionEn">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by Description [EN]">
                        Description [EN]
                        <app-table-column-filter class="column-filter" [class.active]="isActive('descriptionEn')" (filterChange)="applyFilter($event, 'descriptionEn')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.descriptionEn }}</td>
                </ng-container>

                <ng-container matColumnDef="integrityConsequence">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by Integrity consequence">
                        Integrity consequence
                        <app-table-column-filter class="column-filter" [class.active]="isActive('integrityConsequence')" (filterChange)="applyFilter($event, 'integrityConsequence')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.integrityConsequence }}</td>
                </ng-container>

                <ng-container matColumnDef="assetConsequence">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by Asset consequence">
                        Asset consequence
                        <app-table-column-filter class="column-filter" [class.active]="isActive('assetConsequence')" (filterChange)="applyFilter($event, 'assetConsequence')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.assetConsequence }}</td>
                </ng-container>

                <ng-container matColumnDef="gePredixEquipmentType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by GE Predix Equipment Type">
                        GE Predix Equipment Type
                        <app-table-column-filter class="column-filter" [class.active]="isActive('gePredixEquipmentType')" (filterChange)="applyFilter($event, 'gePredixEquipmentType')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.gePredixEquipmentType }}</td>
                </ng-container>

                <ng-container matColumnDef="gePredixPlant">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by GE Predix Plant">
                        GE Predix Plant
                        <app-table-column-filter class="column-filter" [class.active]="isActive('gePredixPlant')" (filterChange)="applyFilter($event, 'gePredixPlant')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.gePredixPlant }}</td>
                </ng-container>

                <ng-container matColumnDef="gePredixUnit">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by GE Predix Unit">
                        GE Predix Unit
                        <app-table-column-filter class="column-filter" [class.active]="isActive('gePredixUnit')" (filterChange)="applyFilter($event, 'gePredixUnit')" />
                    </th>
                    <td mat-cell *matCellDef="let report">{{ report.gePredixUnit }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
                    [class.selected]="selection.isSelected(row)" [class.disabled]="row.status === 'Inactive'"></tr>

            </table>
        </div>
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [length]="dataSource.data.length"
            showFirstLastButtons></mat-paginator>
    </div>
</div>